var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defaultTo, get, set } from "lodash";
import React, { useEffect, useState, } from "react";
import { CheckoutCardThreeDSecureEnum } from "../shared/constants/CheckoutCardThreeDSecureEnum";
import { configCardSections, getCheckoutSection, } from "../shared/constants/CheckoutContants";
import { useCheckoutServiceContext } from "./useCheckoutServiceContext";
import { useKushkiJsContext } from "./useKushkiJsContext";
import { useStateApp } from "../shared/hooks/useStateApp";
import { Translate as T } from "react-localize-redux";
import { COUNTRY_ISO_CODE, ISOCountryEnum, } from "../shared/enums/country_code_iso_enum";
var createContext = React.createContext, useContext = React.useContext;
var ERROR_DAFUALT = {
    error: "",
    code: "K002",
    message: "Ha ocurrido un error inesperado",
};
var CheckoutContext = createContext(undefined);
export var CheckoutProvider = function (_a) {
    var children = _a.children, merchantId = _a.merchantId, inTestEnvironment = _a.inTestEnvironment, onCheckoutTokenChange = _a.onCheckoutTokenChange, paymentMethods = _a.paymentMethods, _b = _a.email, email = _b === void 0 ? "" : _b, amount = _a.amount, currency = _a.currency, paymentType = _a.paymentType, country = _a.country, redirectUrl = _a.redirectUrl, redirectUrlParams = _a.redirectUrlParams, termsAndConditions = _a.termsAndConditions, redirects = _a.redirects, language = _a.language, readOnly = _a.readOnly, enableKpay = _a.enableKpay, hidePayButtonAmount = _a.hidePayButtonAmount, payButtonText = _a.payButtonText, disablePayButton = _a.disablePayButton;
    var _c = useState(configCardSections.paymentMethods), checkoutSection = _c[0], setCheckoutSection = _c[1];
    var _d = useState({
        code: "",
        message: "",
        questionnaireCode: "",
        questions: [],
    }), secureOtp = _d[0], setSecureOtp = _d[1];
    var _e = useState(false), kpayEnable = _e[0], setKpayEnable = _e[1];
    var _f = useState(false), confrontaFail = _f[0], setConfrontaFail = _f[1];
    var _g = useState(false), isCheckout = _g[0], setIsCheckout = _g[1];
    var _h = useState("Identification"), identity = _h[0], setIdentity = _h[1];
    var isMobile = useStateApp().isMobile;
    var _j = useState(), kpayCvvPaymentData = _j[0], setKpayCvvPaymentData = _j[1];
    var _k = useState(false), checkoutLoading = _k[0], setCheckoutLoading = _k[1];
    var _l = useState(), checkoutToken = _l[0], setCheckoutToken = _l[1];
    var _m = useState({
        authorization: "",
    }), verifyAuth = _m[0], setVerifyAuth = _m[1];
    var _o = useState(false), isValidSecureOtp = _o[0], setIsValidSecureOtp = _o[1];
    var _p = useState(false), tokenRequestLoading = _p[0], setTokenRequestLoading = _p[1];
    var _q = useState(""), transferProcessor = _q[0], setTransferProcessor = _q[1];
    var _r = useState(""), transferSubscriptionProcessor = _r[0], setTransferSubscriptionProcessor = _r[1];
    var _s = useState(), checkoutLoadingTexts = _s[0], setCheckoutLoadingTexts = _s[1];
    var _t = useState(), merchantSettingsResponse = _t[0], setMerchantSettingsResponse = _t[1];
    var _u = useState([]), paymentMethodsKpay = _u[0], setPaymentMethodsKpay = _u[1];
    var getMerchantSettings = useCheckoutServiceContext().handlers.getMerchantSettings;
    var requestValidateKPaySession = useKushkiJsContext().requestValidateKPaySession;
    var _v = useState(email), emailKpay = _v[0], setEmailKpay = _v[1];
    var _w = useState(false), isDelete = _w[0], setIsDelete = _w[1];
    var _x = useState(), kpaySelected = _x[0], setKpaySelected = _x[1];
    var _y = useState(""), cardBrandContext = _y[0], setCardBrandContext = _y[1];
    var _z = useState({
        open: false,
    }), errorNotification = _z[0], setErrorNotification = _z[1];
    var showErrorNotification = function (error) {
        setErrorNotification({
            open: true,
            text: ((error === null || error === void 0 ? void 0 : error.code) || ERROR_DAFUALT.code) + " - " + ((error === null || error === void 0 ? void 0 : error.message) || ERROR_DAFUALT.message),
        });
    };
    var closeErrorNotification = function () {
        setErrorNotification({
            open: false,
        });
    };
    var setSectionRedirection = function (targetPaymentMethods) {
        var paymentMethod = targetPaymentMethods[0];
        var section = getCheckoutSection(country, paymentMethod, paymentMethods);
        setCheckoutSection(section);
    };
    var buildCallbackUrl = function (urlParams) {
        var callback_url = new URL(redirectUrl);
        var callbackParams = __assign(__assign({}, urlParams), redirectUrlParams);
        for (var _i = 0, _a = Object.entries(callbackParams); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value_1 = _b[1];
            var isObject = typeof value_1 === "object";
            var paramValue = isObject ? JSON.stringify(value_1) : value_1;
            callback_url.searchParams.append(key, encodeURI(paramValue));
        }
        if (checkoutSection.body === configCardSections.cardSubscriptionAsync.body ||
            checkoutSection.body === configCardSections.cardSubscriptionDynamic.body)
            sessionStorage.setItem("resumeData", JSON.stringify(callbackParams));
        return callback_url.href;
    };
    var buildPayButtonText = function (id) {
        return payButtonText ? payButtonText : React.createElement(T, { id: id });
    };
    var getMaximumFractionPerCountry = function (country) {
        switch (country) {
            case ISOCountryEnum.COLOMBIA:
                return 0;
            case ISOCountryEnum.CHILE:
                return 0;
            default:
                return 2;
        }
    };
    var formatAmount = function (total) {
        if (currency === "UF")
            return total.toFixed(2);
        var formatter = new Intl.NumberFormat(language + "-" + COUNTRY_ISO_CODE[country], {
            currency: currency,
            maximumFractionDigits: getMaximumFractionPerCountry(country),
        });
        return formatter.format(total);
    };
    var buildAmountText = function (currency, total) {
        return !hidePayButtonAmount && amount
            ? " " + formatAmount(total) + " " + currency
            : "";
    };
    var getMerchantSettingsResponse = function () { return __awaiter(void 0, void 0, void 0, function () {
        var merchantSettings, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getMerchantSettings()];
                case 1:
                    merchantSettings = _b.sent();
                    closeErrorNotification();
                    setMerchantSettingsResponse(merchantSettings);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _b.sent();
                    showErrorNotification((_a = e_1.response) === null || _a === void 0 ? void 0 : _a.data);
                    console.error(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var validateKPaySession = function () { return __awaiter(void 0, void 0, void 0, function () {
        var verifyKPaySessionResponse, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, requestValidateKPaySession()];
                case 1:
                    verifyKPaySessionResponse = _a.sent();
                    setEmailKpay(verifyKPaySessionResponse.email);
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _a.sent();
                    setEmailKpay(email);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (merchantSettingsResponse !== undefined) {
            setTransferProcessor(get(merchantSettingsResponse.processors, "transfer[0].processorName"));
            setTransferSubscriptionProcessor(get(merchantSettingsResponse.processors, "transfer-subscriptions[0].processorName"));
        }
        setCheckoutLoading(!merchantSettingsResponse);
    }, [merchantSettingsResponse]);
    useEffect(function () {
        getMerchantSettingsResponse();
        if (enableKpay)
            validateKPaySession();
    }, []);
    var handleOnCheckoutToken = function (chargeToken) {
        setTokenRequestLoading(true);
        chargeToken.contactDetails = __assign({}, defaultTo(checkoutToken.contactDetails, {}));
        if (emailKpay && kpayEnable)
            set(chargeToken, "contactDetails.email", emailKpay);
        chargeToken.kpayEnable = kpayEnable;
        onCheckoutTokenChange(chargeToken, setTokenRequestLoading, cardBrandContext);
    };
    useEffect(function () {
        if ((checkoutToken === null || checkoutToken === void 0 ? void 0 : checkoutToken.secureService) === "KushkiOTP") {
            setCheckoutSection(configCardSections.kushkiOtp);
        }
        else if ((checkoutToken === null || checkoutToken === void 0 ? void 0 : checkoutToken.token) &&
            (checkoutToken === null || checkoutToken === void 0 ? void 0 : checkoutToken.secureService) === "confrontaBiometric" &&
            !confrontaFail &&
            isCheckout) {
            handleOnCheckoutToken(__assign({}, checkoutToken));
        }
        else if ((checkoutToken === null || checkoutToken === void 0 ? void 0 : checkoutToken.token) &&
            (checkoutToken === null || checkoutToken === void 0 ? void 0 : checkoutToken.secureService) === CheckoutCardThreeDSecureEnum.THREEDSECURE) {
            handleOnCheckoutToken(__assign({}, checkoutToken));
        }
        else if ((checkoutToken === null || checkoutToken === void 0 ? void 0 : checkoutToken.token) && !(checkoutToken === null || checkoutToken === void 0 ? void 0 : checkoutToken.secureService)) {
            handleOnCheckoutToken(__assign({}, checkoutToken));
        }
    }, [checkoutToken, confrontaFail, isCheckout]);
    useEffect(function () {
        setSectionRedirection(paymentMethods);
    }, [paymentType]);
    var value = {
        amount: amount,
        checkoutLoading: checkoutLoading,
        checkoutLoadingTexts: checkoutLoadingTexts,
        checkoutSection: checkoutSection,
        checkoutToken: checkoutToken,
        confrontaFail: !!confrontaFail,
        country: country,
        currency: currency,
        emailKpay: emailKpay,
        handlers: {
            buildCallbackUrl: buildCallbackUrl,
            setCheckoutLoading: setCheckoutLoading,
            setCheckoutLoadingTexts: setCheckoutLoadingTexts,
            setCheckoutSection: setCheckoutSection,
            setCheckoutToken: setCheckoutToken,
            setConfrontaFail: setConfrontaFail,
            setEmailKpay: setEmailKpay,
            setIdentity: setIdentity,
            setIsCheckout: setIsCheckout,
            setIsDelete: setIsDelete,
            setIsValidSecureOtp: setIsValidSecureOtp,
            setKpayCvvPaymentData: setKpayCvvPaymentData,
            setKpayEnable: setKpayEnable,
            setKpaySelected: setKpaySelected,
            setPaymentMethodsKpay: setPaymentMethodsKpay,
            setSectionRedirection: setSectionRedirection,
            setSecureOtp: setSecureOtp,
            setTokenRequestLoading: setTokenRequestLoading,
            setVerifyAuth: setVerifyAuth,
            showErrorNotification: showErrorNotification,
            closeErrorNotification: closeErrorNotification,
            setCardBrandContext: setCardBrandContext,
        },
        isCheckout: isCheckout,
        identity: identity,
        inTestEnvironment: inTestEnvironment,
        isDelete: isDelete,
        isValidSecureOtp: isValidSecureOtp,
        kpayEnable: kpayEnable,
        kpaySelected: kpaySelected,
        kpaySelectedPayment: kpayCvvPaymentData,
        merchantId: merchantId,
        merchantSettingsResponse: merchantSettingsResponse,
        onCheckoutTokenChange: onCheckoutTokenChange,
        paymentMethods: paymentMethods,
        paymentMethodsKpay: paymentMethodsKpay,
        paymentType: paymentType,
        redirectUrl: redirectUrl,
        redirectUrlParams: redirectUrlParams,
        secureOtp: secureOtp,
        tokenRequestLoading: tokenRequestLoading,
        transferProcessor: transferProcessor,
        transferSubscriptionProcessor: transferSubscriptionProcessor,
        isMobile: isMobile,
        verifyAuth: verifyAuth,
        termsAndConditions: termsAndConditions,
        redirects: redirects,
        language: language,
        readOnly: readOnly,
        enableKpay: enableKpay,
        errorNotification: errorNotification,
        buildPayButtonText: buildPayButtonText,
        buildAmountText: buildAmountText,
        disablePayButton: disablePayButton,
    };
    return (React.createElement(CheckoutContext.Provider, { value: value }, children));
};
export var useCheckoutContext = function () {
    return useContext(CheckoutContext);
};
